<div class="login-wrapper">
  <div class="content-wrapper">
    <h1>kis portás Admin</h1>
    <div class="form-wrapper">
      <form (submit)="signIn()" #loginForm="ngForm">
        <custom-input
          [type]="'email'"
          [name]="'username'"
          label="Felhasználónév"
          [required]="true"
          [(ngModel)]="loginGroup.username"
          />

        <br />
        <custom-input
          [type]="'password'"
          [name]="'password'"
          [required]="true"
          [(ngModel)]="loginGroup.password"
          label="Jelszó"
          />

        <br />
        <button
          class="primary-button"
          type="submit"
          [disabled]="loginForm.invalid"
          >
          @if (!isLoading) {
            <span>Belépés</span>
          }
          @if (isLoading) {
            <app-loading-spinner></app-loading-spinner>
          }
        </button>
      </form>
    </div>
  </div>
  <!-- <div class="version"><span>v</span>TODO</div> -->
</div>
